export function importantify(styles) {
  return Object.fromEntries(
    Object.entries(styles)
      .filter(([_, val]) => ![null, undefined].includes(val))
      .map(([key, val]) => [key, val + '!important'])
  );
}

export function camelToSnake(str) {
  return str.replace(/([A-Z]+|[0-9]+)/g, '_$1').toLowerCase();
}
